define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/def/ViewRef",
	"csi/xml",
	"./AggregateIncrementSizesMixin",

	"SiteAdmin/ToolbarPluginLocalizedItem"
], function(declare,lang,_,ViewRef,xml,AggregateIncrementSizesMixin) {

	return declare(AggregateIncrementSizesMixin, {

		getAggregateSizesViewRef: function() {
			// If Increment has size range, only sizes of size range, otherwise, show all sizes -->
			var sizeRangeUrl = this.getCurrentSizeRangeUrl(this.getNode());
			return lang.mixin(new ViewRef(), {
                m_id: "Sizes",
                m_url: xml.isValidURL(sizeRangeUrl) ?  sizeRangeUrl : "centric://APPAREL/Views"
			});
		},

		toWriterRequest: function() {
			var call = this.inherited(arguments);

			// summary: write request to server on Select (add/remove) Sizes
			var	increment = this.getParent();
			var formData = this.getFormData();

			var	nodesAdded = this._getAggregateSelections(formData);
			var adds = !_.isEmpty(nodesAdded) ? _.map(nodesAdded, xml.nodeGetURL) : null;

			var	nodesRemoved = this._getAggregateRemovals(formData);
			var removes = !_.isEmpty(nodesRemoved) ? _.map(nodesRemoved, xml.nodeGetURL) : null;

			// write request if change was made
			// TODO: refactor the server operation and split it into three
			if (adds || removes) {
				call
					.addParameter(xml.PROP_AGGREGATE_ADDS, xml.ATTR_REFLIST, adds)
					.addParameter(xml.PROP_AGGREGATE_REMOVES, xml.ATTR_REFLIST, removes)
					.addParameter("SizeRangeURL", xml.ATTR_REF, this.getCurrentSizeRangeUrl(increment));

				this.setProgress();
			}

			return call;
		},

		postProcessSuccess: function() {
			// refresh store for base size selection if wizard shown or sizes were changed
			var	view = this.widget;
			view.refreshHeadingStore(view.defView.findHeading(this.idBaseSize));

			this.inherited(arguments);
		}
	});
});